"use client"

import { Localized } from "@/i18n/client"
import { useState } from "react"
import dynamic from "next/dynamic"

import { SiteHeader } from "@/components/site/site-header"
import type {
  AccountContent,
  NavigationContent,
  NavigationPanel,
  NavigationPanelId,
} from "@/content/navigation"
import type { HeaderContent } from "@/content/types"
const AccountDialog = dynamic(() => import("./account-dialog").then(module => module.AccountDialog))
const SiteNavigationDialog = dynamic(() => import("./site-navigation-dialog").then(module => module.SiteNavigationDialog))

type SiteNavigationControllerProps = {
  header: HeaderContent
  navigation: NavigationContent
  panels: readonly NavigationPanel[]
  account: AccountContent
  onLocationSearchAction?: (
    query: string,
    radiusMiles: number
  ) => void | Promise<void>
  onCurrentLocationAction?: () => void | Promise<void>
}

export function SiteNavigationController({
  header,
  navigation,
  panels,
  account,
  onLocationSearchAction,
  onCurrentLocationAction,
}: SiteNavigationControllerProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [accountOpen, setAccountOpen] = useState(false)
  const [menuMounted, setMenuMounted] = useState(false)
  const [accountMounted, setAccountMounted] = useState(false)
  const [activePanelId, setActivePanelId] =
    useState<NavigationPanelId | null>(null)

  const openMenu = () => {
    setMenuMounted(true)
    setActivePanelId(null)
    setMenuOpen(true)
  }

  const switchAccountToMenu = (panelId: NavigationPanelId) => {
    setMenuMounted(true)
    setAccountOpen(false)
    setActivePanelId(panelId)
    setMenuOpen(true)
  }

  const openAccount = () => { setAccountMounted(true); setAccountOpen(true) }

  return <Localized>{(
    <>
      <SiteHeader
        content={header}
        onMenuOpen={openMenu}
        onAccountOpen={openAccount}
      />
      {menuMounted && <SiteNavigationDialog
        content={navigation}
        panels={panels}
        open={menuOpen}
        activePanelId={activePanelId}
        onPanelChange={setActivePanelId}
        onOpenChange={setMenuOpen}
        onAccountOpen={openAccount}
        onLocationSearchAction={onLocationSearchAction}
        onCurrentLocationAction={onCurrentLocationAction}
      />}
      {accountMounted && <AccountDialog
        content={account}
        panels={panels}
        open={accountOpen}
        onOpenChange={setAccountOpen}
        onSwitchToMenu={switchAccountToMenu}
      />}
    </>
  )}</Localized>
}
